<mat-form-field style="min-width: 250px" appearance="outline">
    <mat-label>{{'Pays'|transloco}}</mat-label>
    <input
        [matAutocomplete]="auto"
        matInput
        (input)="filterCountries($event)"
        [value]="selectedCountryName"
    >
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="changeCountry($event)" [displayWith]="displayFn">
        <mat-option *ngFor="let country of filteredCountries" [value]="country">
            {{country.name}}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
